/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';

// defines the props definitions shared between the daterangepicker components.
export interface DateRange {
  fromDate?: Date;
  toDate?: Date;
}

export type Setter<T> = React.Dispatch<React.SetStateAction<T>> | ((value: T) => void);

export enum NavigationAction {
  Previous = -1,
  Next = 1
}

export enum MonthsEnum {
  Jan = 1,
  Feb = 2,
  Mar = 3,
  Apr = 4,
  May = 5,
  June = 6,
  July = 7,
  Aug = 8,
  Sept = 9,
  Oct = 10,
  Nov = 11,
  Dec = 12
};

export enum Meridiem {
  AM = 'AM',
  PM = 'PM'
}

export enum TimeModificationAction {
  HourUp = 1,
  HourDown = -1,
  MinuteUp = 2,
  MinuteDown = -2,
  ToggleMeridiem = 3
}
